<template>
  <div class="filter-box new-select-box">
    <el-select v-if="filterList.includes(1)" v-model="dateValue" :placeholder="$t('courses.filter.day')" popper-class="new-dropdown" @change="(...args) => selectChange(...args,'day')">
      <el-option
        v-for="(item, index) in newDateList"
        :key="index"
        :label="item"
        :value="item"
      />
    </el-select>
    <el-select v-if="filterList.includes(2)" v-model="timeValue" :placeholder="$t('courses.filter.time')" popper-class="new-dropdown" @change="(...args) => selectChange(...args,'time')">
      <el-option
        v-for="(item, index) in newTimeList"
        :key="index"
        :label="item"
        :value="item"
      />
    </el-select>
    <el-select v-if="filterList.includes(3)" v-model="levelValue" :placeholder="$t('courses.filter.level')" popper-class="new-dropdown" @change="(...args) => selectChange(...args,'level')">
      <el-option
        v-for="(item, index) in newLevelList"
        :key="index"
        :label="item.name"
        :value="item.level"
      />
    </el-select>
    <el-select v-if="filterList.includes(4)" v-model="gradeValue" :placeholder="$t('courses.filter.grade')" popper-class="new-dropdown" @change="(...args) => selectChange(...args,'grade')">
      <el-option
        v-for="(item, index) in newGradeList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>
<script>
export default {
  props: {
    dateList: {
      type: Array,
      default: () => ['mon', 'tus'],
    },
    timeList: {
      type: Array,
      default: () => [],
    },
    levelList: {
      type: Array,
      default: () => [],
    },
    gradeList: {
      type: Array,
      default: () => [],
    },
    filterList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dateValue: '',
      timeValue: '',
      levelValue: '',
      gradeValue: '',
      newDateList: [],
      newTimeList: [],
      newLevelList: [],
      newGradeList: [],
    }
  },
  watch: {
    dateList: {
      handler(val) {
        this.newDateList = []
        this.newDateList.push('All')
        this.newDateList = this.newDateList.concat(val)
      },
      deep: true,
      immediate: true,
    },
    timeList: {
      handler(val) {
        this.newTimeList = []
        this.newTimeList = val.map((item) => `${item.lessonTimeBegin}-${item.lessonTimeEnd}`)
        this.newTimeList.unshift('All')
      },
      deep: true,
      immediate: true,
    },
    levelList: {
      handler(val) {
        this.newLevelList = []
        this.newLevelList.push({
          name: 'All',
          level: 'All',
        })
        this.newLevelList = this.newLevelList.concat(val)
      },
      deep: true,
      immediate: true,
    },
    gradeList: {
      handler(val) {
        this.newGradeList = []
        this.newGradeList.push({
          name: 'All',
          id: 'All',
        })
        this.newGradeList = this.newGradeList.concat(val)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    selectChange(value, type) {
      if (value === 'All') {
        switch (type) {
          case 'day':
            this.dateValue = ''
            break;
          case 'time':
            this.timeValue = ''
            break;
          case 'level':
            this.levelValue = ''
            break;
          case 'grade':
            this.gradeValue = ''
            break;
          default:
            break;
        }
      }
      this.$emit('change', { type, value })
    },
    reset() {
      this.dateValue = ''
      this.timeValue = ''
      this.levelValue = ''
      this.gradeValue = ''
    },
  },
}
</script>
<style lang="scss" scoped>
  .filter-box {
    width: 1240px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    border-radius: 12px;

    .el-select {
      margin-right: 30px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
</style>
